export const translations = {
    tr: {
        navbar: {
            home: "Ana Sayfa",
            about: "Hakkımızda",
            events: "Etkinlikler",
            team: "Ekibimiz",
            contact: "İletişim",
            map: "Üye Haritası",
            announcements: "Duyurular",
            jobs: "İş İlanları",
            reports: "Raporlar"
        },
        header: {
            join: "Üye Ol"
        },
        about: {
            vision: "Vizyonumuz",
            mission: "Misyonumuz",
            aims: "Birliğin Amaçları",
            whoCanJoin: "Kimler Üye Olabilir?"
        },
        events: {
            title: "Etkinlikler",
            details: "Detaylar",
            noEvents: "Şu anda yaklaşan bir etkinliğimiz bulunmamaktadır."
        },
        team: {
            title: "Ekibimiz",
            board: "YÖNETİM KURULU",
            discipline: "DİSİPLİN KURULU",
            supervisory: "DENETLEME KURULU",
            career: "KARİYER TEMSİLCİLERİ",
            country: "ÜLKE TEMSİLCİLERİ"
        },
        footer: {
            address: "Adres",
            phone: "Telefon",
            email: "E-posta",
            social: "Sosyal Medya"
        },
        map: {
            title: "Üye Dağılımı",
            subtitle: "Dünyanın dört bir yanındaki üyelerimizle büyüyen bir aileyiz.",
            stats: {
                members: "Üye",
                sectors: "Farklı Sektör",
                countries: "Ülke"
            },
            listHeader: "En Çok Üye Olan Ülkeler",
            tooltip: "Üye"
        },
        announcements: {
            title: "Duyurular",
            subtitle: "KTGPB'den en son haberler ve güncellemeler",
            readMore: "Devamını Oku",
            noAnnouncements: "Şu anda duyuru bulunmamaktadır."
        },
        contact: {
            title: "İletişim",
            subtitle: "Sorularınız mı var? Bizimle iletişime geçin.",
            emailUs: "E-posta",
            form: {
                name: "İsim",
                email: "E-posta",
                subject: "Konu",
                message: "Mesaj",
                send: "Gönder"
            }
        },
        common: {
            downloadStatute: "Tüzüğü İndir",
            memberList: "Üye Listesi (Üyelere Özel)",
            contactUs: "Bize Ulaşın",
            rightsReserved: "Tüm hakları saklıdır.",
            privacy: "Gizlilik Politikası"
        },
        jobs: {
            title: "İş İlanları",
            subtitle: "Topluluğumuz tarafından paylaşılan kariyer fırsatları",
            apply: "Başvur",
            noJobs: "İlan bulunamadı",
            submitTitle: "İş İlanı Paylaşmak İster Misiniz?",
            submitDesc: "Topluluğumuzla paylaşmak istediğiniz bir iş fırsatı varsa, aşağıdaki formu doldurarak bize iletebilirsiniz.",
            submitBtn: "İlan Gönder"
        },
        reports: {
            title: "Raporlar",
            subtitle: "KTGPB tarafından yürütülen araştırmalar, anketler ve analizler",
            published: "Yayım Tarihi",
            surveyDate: "Anket Tarihi",
            participants: "Katılımcı",
            slides: "Slayt",
            view: "Raporu Görüntüle",
            downloadPdf: "PDF İndir",
            backToList: "Raporlara Dön",
            slide: "Slayt",
            of: "/",
            previous: "Önceki",
            next: "Sonraki",
            fullscreen: "Tam Ekran",
            exitFullscreen: "Tam Ekrandan Çık",
            keyFindings: "Öne Çıkan Bulgular",
            noReports: "Henüz yayımlanmış rapor bulunmamaktadır."
        }
    },
    en: {
        navbar: {
            home: "Home",
            about: "About Us",
            events: "Events",
            team: "Our Team",
            contact: "Contact",
            map: "Member Map",
            announcements: "Announcements",
            jobs: "Job Listings",
            reports: "Reports"
        },
        header: {
            join: "Join Us"
        },
        about: {
            vision: "Our Vision",
            mission: "Our Mission",
            aims: "Aims of the Union",
            whoCanJoin: "Who Can Join?"
        },
        events: {
            title: "Events",
            details: "Details",
            noEvents: "There are no upcoming events at the moment."
        },
        team: {
            title: "Our Team",
            board: "BOARD OF DIRECTORS",
            discipline: "DISCIPLINARY BOARD",
            supervisory: "SUPERVISORY BOARD",
            career: "CAREER REPRESENTATIVES",
            country: "COUNTRY REPRESENTATIVES"
        },
        footer: {
            address: "Address",
            phone: "Phone",
            email: "Email",
            social: "Social Media"
        },
        map: {
            title: "Member Distribution",
            subtitle: "We are a growing family with members all around the world.",
            stats: {
                members: "Members",
                sectors: "Different Sectors",
                countries: "Countries"
            },
            listHeader: "Top Countries",
            tooltip: "Members"
        },
        announcements: {
            title: "Announcements",
            subtitle: "Latest news and updates from KTGPB",
            readMore: "Read More",
            noAnnouncements: "There are no announcements at the moment."
        },
        contact: {
            title: "Contact",
            subtitle: "Have questions? Get in touch with us.",
            emailUs: "Email",
            form: {
                name: "Name",
                email: "Email",
                subject: "Subject",
                message: "Message",
                send: "Send"
            }
        },
        common: {
            downloadStatute: "Download Statute",
            memberList: "Member List (Members Only)",
            contactUs: "Contact Us",
            rightsReserved: "All rights reserved.",
            privacy: "Privacy Policy"
        },
        jobs: {
            title: "Job Listings",
            subtitle: "Career opportunities shared by our community",
            apply: "Apply",
            noJobs: "No jobs found",
            submitTitle: "Want to Share a Job Listing?",
            submitDesc: "If you have a job opportunity you'd like to share with our community, fill out the form below and we'll post it here.",
            submitBtn: "Submit a Job"
        },
        reports: {
            title: "Reports",
            subtitle: "Research, surveys and analyses conducted by KTGPB",
            published: "Published",
            surveyDate: "Survey Period",
            participants: "Participants",
            slides: "Slides",
            view: "View Report",
            downloadPdf: "Download PDF",
            backToList: "Back to Reports",
            slide: "Slide",
            of: "/",
            previous: "Previous",
            next: "Next",
            fullscreen: "Fullscreen",
            exitFullscreen: "Exit Fullscreen",
            keyFindings: "Key Findings",
            noReports: "No reports have been published yet."
        }
    }
};